'use client'

import { User } from '@/types'
import React, { createContext, useContext, useState } from 'react'

interface UserContextType {
  user: User | null
  setUser: (user: User | null) => void
}

const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => { },
})

export const useUser = () => useContext(UserContext)

interface UserProviderProps {
  initialUser: User | null
  children: React.ReactNode
}

export const UserProvider: React.FC<UserProviderProps> = ({
  initialUser,
  children
}) => {
  const [user, setUser] = useState<User | null>(initialUser)



  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  )
}

export default UserContext